import * as R from 'ramda';

const saveProblemHistory = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

const updateProblemHistory = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

const getProblemHistory = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

const archiveProblem = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};


const deleteProblem = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

const addProblemNote = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

const getProblemNotes = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

const markProblemNoteAsError = {
  fe2be: R.identity,
  be2fe: ({ value }) => ({ value }),
};

export default {
  saveProblemHistory,
  updateProblemHistory,
  getProblemHistory,
  archiveProblem,
  deleteProblem,
  addProblemNote,
  getProblemNotes,
  markProblemNoteAsError
};